module.exports = __webpack_public_path__ + "media/start_page5.f9fccd27.mp3";